import { createFileRoute } from '@tanstack/react-router';
import { CleanerRegistrationInfo } from '@/features/cleaner/registrations/cleaner-info';

export const Route = createFileRoute(
  '/(cleaner)/_registration/cleaner/signup-info'
)({
  component: CleanerRegistrationInfo,
});
